export enum CaptureActivityActions {
  captureSnapshotCreated = 'capture_snapshot_created',
}
